import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { Button } from '@/components/UI/Button/Button';
import { Drawer as DrawerComponent } from '@/components/Drawer/Drawer';

export const InfoDrawer = styled(DrawerComponent)`
  z-index: 10203;
`;

export const InfoDrawerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 450px;
  padding: 30px 50px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};
  border-radius: 7px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
    height: 100%;
    padding: 15px;
    border: none;
    border-radius: 0;
  }
`;

export const InfoDrawerLogo = styled(IconBox).attrs({
  $filename: 'Tap.svg',
  $width: 60,
  $height: 18,
  $iconWidth: 60,
  $iconHeight: 18,
})`
  margin-bottom: 20px;
  width: 80px;
`;

export const InfoDrawerTitle = styled(Typography.Header).attrs({
  $variant: '2',
})<{ $isError: boolean }>`
  font-weight: 500;

  ${({ $isError }) =>
    $isError &&
    css`
      color: ${({ theme }) => theme.palette.system.red};
    `}
`;

export const InfoDrawerMessage = styled(Typography.Body).attrs({
  $variant: '1',
})`
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const InfoDrawerButton = styled(Button).attrs({
  appearance: 'secondaryLight',
  isFullWidth: true,
})`
  max-width: 400px;
`;

export const InfoDrawerLink = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.system.blue};
  text-decoration-line: underline;
  text-underline-position: under;
`;
